import t from '@jetshop/intl';
import React, { useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import PriceHistoryQuery from './PriceHistoryQuery.gql';
import { styled } from 'linaria/react';
import { Price } from '@jetshop/ui/Price';
import ChannelContext from '@jetshop/core/components/ChannelContext/ChannelContext';

const Wrapper = styled.div`
  .price-table {
    h3 {
      margin-bottom: 12px;
      font-weight: 300;
    }

    ul {
      margin-block: 0;
      margin-inline: 0;
      padding-inline: 0;
    }

    span {
      margin-top: 0;
      margin-bottom: 0;
    }

    .label {
      flex: 1;
      /* font-weight: 600; */
    }

    .price-wrapper {
      flex: 1;
      text-align: center;
    }

    li {
      padding: 4px 10px;
      display: flex;
      /* justify-content: flex-start; */
      justify-content: space-between;
      align-items: center;
    }

    li:nth-child(odd) {
      background: #f4f4f4;
    }
  }

  .price-table::-webkit-scrollbar {
    display: none;
  }
`;

export function PriceHistoryWrapper(props) {
  return (
    <Wrapper>
      <PriceHistory {...props} />
    </Wrapper>
  );
}

const days = 30;
function PriceHistory({ articleNumber, variant }) {
  const { error, loading, data } = useQuery(PriceHistoryQuery, {
    variables: { articleNumber, days },
    errorPolicy: 'all',
    skip: !articleNumber
  });

  if (loading || error) {
    return (
      <div className="price-table">
        {loading && (
          <span className="label">
            {t('Getting the last { days } days price changes...', {
              days
            })}
          </span>
        )}
        {error && <span className="label">{t('Something went wrong')}</span>}
      </div>
    );
  }

  const { product } = data;

  if (!variant) {
    return (
      <div className="price-table">
        <h3>Velg størrelse for å se prishistorikk.</h3>
      </div>
    );
  }

  const selectedVariant = product.variants.values.find(
    value => value.articleNumber === variant.articleNumber
  );

  const previousPrice = selectedVariant?.history?.previousPrice;

  const highest = previousPrice?.reduce((prev, current) => {
    return prev?.price?.incVat > current?.price?.incVat ? prev : current;
  });

  const lowest = previousPrice?.reduce((prev, current) => {
    return prev?.price?.incVat < current?.price?.incVat ? prev : current;
  });

  return (
    <>
      <Table
        history={selectedVariant.history}
        days={days}
        current={variant}
        highest={highest}
        lowest={lowest}
      />
    </>
  );
}

const Table = ({ history, days, current, lowest, highest }) => {
  const { selectedChannel } = useContext(ChannelContext);

  if (history?.previousPrice?.length === 0) {
    return (
      <div className="price-table">
        <span className="label">
          {t('The price has not changed in the last { days } days', { days })}
        </span>
      </div>
    );
  }

  return (
    <div className="price-table">
      <h3>Prishistorikk for varen siste {days} dager.</h3>
      <ul>
        <li>
          <span className="label">Nåværende pris:</span>
          <span className="price-wrapper">
            <Price price={current?.price} as="span" />
            ,-
          </span>
          <p>
            (
            {new Date(lowest?.timestamp).toLocaleDateString([
              selectedChannel?.language?.culture
            ])}
            )
          </p>
        </li>
        <li>
          <span className="label">Ordinær pris:</span>
          <span className="price-wrapper">
            <Price price={highest?.price} as="span" />
            ,-
          </span>
          <p>
            (
            {new Date(highest?.timestamp).toLocaleDateString([
              selectedChannel?.language?.culture
            ])}
            )
          </p>
        </li>
        <li>
          <span className="label">Laveste pris:</span>
          <span className="price-wrapper">
            <Price price={lowest?.price} as="span" />
            ,-
          </span>
          <p>
            (
            {new Date(lowest?.timestamp).toLocaleDateString([
              selectedChannel?.language?.culture
            ])}
            )
          </p>
        </li>
      </ul>
    </div>
  );
};
